<template>
  <div class="interface-preview-wrapper">
    <v-row>
      <v-col cols="10" sm="4"> Channel QR </v-col>
      <v-col cols="2" sm="1"> : </v-col>
      <v-col cols="12" sm="7"> {{ channelQrText || '( not set )' }} </v-col>
    </v-row>
    <v-row>
      <v-col cols="10" sm="4"> Model Usaha </v-col>
      <v-col cols="2" sm="1"> : </v-col>
      <v-col cols="12" sm="7"> {{ merchantModelText || '( not set )' }} </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'InterfacePreview',

  props: {
    channelQr: {
      type: [String, Object],
      default: ''
    },
    merchantModel: {
      type: [String, Object],
      default: null
    },
    selectedInterfaces: {
      type: Array,
      default: () => []
    },
    merchantModelList: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    channelQrText() {
      if (!this.channelQr) return '';
      
      if (typeof this.channelQr === 'object' && this.channelQr.code && this.channelQr.desc) {
        return `${this.channelQr.code} - ${this.channelQr.desc}`;
      }
      
      return this.channelQr;
    },

    merchantModelText() {
      if (!this.merchantModel) return '';
      
      if (typeof this.merchantModel === 'string') {
        const item = this.merchantModelList.find(m => m.value === this.merchantModel);
        return item ? item.text : this.merchantModel;
      }
      
      return this.merchantModel?.text || '';
    },
  }
};
</script>

<style scoped>
.interface-preview-wrapper {
  width: 100%;
  padding: 0;
  margin: 0;
}
</style>
